//Angular
import {Component, Inject, OnInit, ViewEncapsulation} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatDialog} from "@angular/material";

//Model
import {Product} from "../../../../persistence/circular-dto/product.conflict";

//Service
import {CatalogProductDto} from "../../../../model/club-gigot/catalog/catalog-product.dto";
import {SaveCatalogProductDto, SaveProductDto} from "../../../../model/club-gigot/catalog/save-catalog-product.dto";
import {CatalogService} from "../../../../service/club-gigot/catalog.service";
import {SaveCatalogProductResultModel} from "../../../../model/club-gigot/catalog/save-catalog-product-result.model";
import {finalize} from "rxjs/operators";
import {QueryParamsModel, QueryResultsModel} from "../../../../core/_base/crud";
import { CategoryProductDTO } from "../../../../model/club-gigot/inventory-points/product-category/category-product.dto";
import { ClaimedProductDto } from "../../../../model/club-gigot/user-points/claimed-product.dto";
import { AlertComponent } from '../../alert/alert.component';
import {
    ActionPointsAdvancedSaleChoiceResultsModel
} from "../../../../model/club-gigot/action-points/action-points-advanced-sale-choice-results.model";
import {ConfirmComponent} from "../../confirm/confirm.component";

@Component({
  selector: 'cg-dialog-catalog-campaign-product',
  templateUrl: './dialog-catalog-campaign-product.component.html',
  styleUrls: ['./dialog-catalog-campaign-product.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogCatalogCampaignProductComponent implements OnInit {

    public loading$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public productsForm : FormGroup;
    public displayedColumns = ['product', 'points', 'category', 'suggested', 'noStock', 'actions'];
    public tableDataSource: MatTableDataSource<any>;
    public isEdit: boolean;

    private existing: CatalogProductDto[];

    public categories: CategoryProductDTO[];

    constructor( private dialogRef: MatDialogRef<DialogCatalogCampaignProductComponent>,
                 private catalogService: CatalogService,
                 private dialog: MatDialog,
                 @Inject(MAT_DIALOG_DATA)
                 public data: DialogData,) { }

    ngOnInit() {
        this.loadCategories();
        this.isEdit = this.data.selected == undefined;
        if(!this.isEdit){
            this.loadProducts(999);
        }
        this.buildForm();
        this.tableDataSource = new MatTableDataSource(this.getFormArray().controls);
    }

    private loadCategories() : void {
        this.catalogService.getCatalogCategories(this.data.campaignSequence)
          .subscribe({
            next : (categories : CategoryProductDTO[]) => this.categories = categories,
            error : (error : Error) => console.log(error)
          });
    }

    private loadProducts(size: number): void {
        this.catalogService.getCatalogProducts(new QueryParamsModel({"Name": "", "CategoriesID": []}, 'asc', 'Id', 1, size), this.data.campaignSequence).subscribe({
            next: (products: QueryResultsModel) => {
                if(size < products.totalCount){
                    this.loadProducts(products.totalCount);
                }else {
                    this.existing = products.items
                }
            },
            error: (err: Error) => {
                console.log(err);
            }
        })
    }

    private setProductForm(): FormGroup[] {
        let form: FormGroup[] = [];
        if(!this.isEdit){
            for(let product of this.data.selected){
                let formGroup = new FormGroup(
                    {
                        product: new FormControl(product),
                        points: new FormControl(null, [Validators.required, Validators.min(1)]),
                        categoryId : new FormControl(null, [Validators.required]),
                        suggested: new FormControl(false),
                        noStock: new FormControl(false, [Validators.required])
                    }
                )
                form.push(formGroup)
            }
        }else {
           for(let product of this.data.existing){
               let prod: Product = new Product();
               prod.name = product.name;
               prod.id = product.id;
               prod.imagePath = product.imageURL;
               prod.campaignProductId = product.campaignProductId;
               let formGroup = new FormGroup(
                   {
                       product: new FormControl(product),
                       points: new FormControl(product.points, [Validators.required, Validators.min(1)]),
                       categoryId : new FormControl(product.categoryId, [Validators.required]),
                       suggested: new FormControl(product.isSuggested),
                       noStock: new FormControl(product.noStock, [Validators.required])

                   }
               )
               form.push(formGroup)
           }
        }
        return form;
    }

    private buildForm(){
        this.productsForm = new FormGroup({
            products: new FormArray(this.setProductForm())
        })
    }

    public getFormArray(): FormArray{
        return this.productsForm.controls['products'] as FormArray;
    }

    //Acciones
    public onCreateCatalogProducts(): void{
        this.loading$.next(true);
        let products: SaveCatalogProductDto = new SaveCatalogProductDto();
        products.products = [];
        if(!this.isEdit){
            products.products = this.existing.map(product => {
                let prod = new SaveProductDto();
                prod.productInventoryId = product.productInventoryId;
                prod.categoryId = product.categoryId;
                prod.isSuggested = product.isSuggested;
                prod.points = product.points;
                prod.noStock = product.noStock;
                prod.campaignProductId = product.campaignProductId;
                return prod;
            })
        }
        this.getFormArray().controls.forEach(c => {
            let prod = new SaveProductDto();
            prod.productInventoryId = (this.isEdit)? c.value.product.productInventoryId :  c.value.product.id;
            prod.isSuggested = c.value.suggested;
            prod.points = c.value.points;
            prod.categoryId = c.value.categoryId;
            prod.noStock = c.value.noStock;
            prod.campaignProductId = c.value.product.campaignProductId;
            products.products.push(prod);
        })

        this.catalogService.saveCatalogProducts(products, this.data.campaignSequence)
            .pipe(
                finalize(() =>{
                    this.loading$.next(false);
                })
            )
            .subscribe({
            next: _ =>{
                this.dialogRef.close(new SaveCatalogProductResultModel(false, true, this.data.campaignSequence))
            },
            error: (err: Error) =>{
                this.dialogRef.close(new SaveCatalogProductResultModel(false, false, this.data.campaignSequence, err.message))
            }
        })
    }

    public deleteProduct(index: number): void{
        let deleteProduct = this.getFormArray().at(index).value;
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '400px',
            data: {
                mensaje: "Seguro que desea eliminar el producto?",
                title: 'Eliminar'
            }
        }).afterClosed().subscribe(result => {
            if(!result) return;
            else if(result === "ok"){
                this.catalogService.checkClaimedRewards(deleteProduct.product.campaignProductId).subscribe({
                    next : (response : ClaimedProductDto[]) => {
                        if (response.length == 0) {
                            this.getFormArray().removeAt(index);
                            this.tableDataSource =new MatTableDataSource(this.getFormArray().controls);
                        }
                        else{
                            const dialogRef = this.dialog.open(AlertComponent, {
                                width: '400px',
                                data: {
                                    mensaje: "No es posible eliminar el producto" ,
                                    title: 'Error'
                                }
                            });
                        }
                    },
                    error : (error : Error) => console.log(error)
                })
            }
        });
    }

    public onNoClick(): void {
        this.dialogRef.close(new SaveCatalogProductResultModel(true));
    }
}

export interface DialogData {
    selected: Product[];
    existing: CatalogProductDto[];
    campaignSequence: number;
}

